import { useEffect, useRef, useState } from "react";

const TypedAnimation = ({ text, delay, mainClassName }) => {
    const [currentText, setCurrentText] = useState('');
    const indexRef = useRef(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        // Сброс
        setCurrentText('');
        indexRef.current = 0;

        // Очистка старых таймеров
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        const typeNextChar = () => {
            const nextIndex = indexRef.current;
            if (nextIndex < text.length) {
                // Используем prev => prev + следующий символ
                setCurrentText(prev => prev + text.charAt(nextIndex));
                indexRef.current += 1;
                timeoutRef.current = setTimeout(typeNextChar, delay);
            }
        };

        // Небольшая задержка перед стартом (важно для Safari)
        timeoutRef.current = setTimeout(typeNextChar, delay);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [text, delay]);

    return <h2 className={mainClassName}>{currentText}</h2>;
};

export default TypedAnimation